export function AbbottPropuestaMenopausiaPage() {
  return (
    <iframe
      src="/dash/abbott/propuesta-menopausia.html"
      title="Abbott — Propuesta Menopausia"
      style={{ width: '100%', height: '100vh', border: 'none', display: 'block' }}
    />
  )
}
